export const courses = [
  {
    id: 1,
    title: "كورس وعي الغذاء صلاة",
    price: 499,
    rating: 5.0,
    image: "https://customer-assets.emergentagent.com/job_8c1ccbd6-9b69-4f77-851f-db987073ebdb/artifacts/cf2j0myj_image.webp"
  },
  {
    id: 2,
    title: "كورس التشافي بالمعرفة الشاملة",
    price: 444,
    rating: 5.0,
    image: "https://customer-assets.emergentagent.com/job_8c1ccbd6-9b69-4f77-851f-db987073ebdb/artifacts/cf2j0myj_image.webp"
  },
  {
    id: 3,
    title: "كورس الشامل في التأمل",
    price: 555,
    rating: 5.0,
    image: "https://customer-assets.emergentagent.com/job_8c1ccbd6-9b69-4f77-851f-db987073ebdb/artifacts/cf2j0myj_image.webp"
  },
  {
    id: 4,
    title: "كورس الماستر بالنور المقدس",
    price: 693,
    rating: 5.0,
    image: "https://customer-assets.emergentagent.com/job_8c1ccbd6-9b69-4f77-851f-db987073ebdb/artifacts/cf2j0myj_image.webp"
  },
  {
    id: 5,
    title: "كورس التأملات الالماسية",
    price: 396,
    rating: 5.0,
    image: "https://customer-assets.emergentagent.com/job_8c1ccbd6-9b69-4f77-851f-db987073ebdb/artifacts/cf2j0myj_image.webp"
  },
  {
    id: 6,
    title: "كورس جواب العارفين",
    price: 888,
    rating: 5.0,
    image: "https://customer-assets.emergentagent.com/job_8c1ccbd6-9b69-4f77-851f-db987073ebdb/artifacts/cf2j0myj_image.webp"
  },
  {
    id: 7,
    title: "كورس التناغم العجيب",
    price: 1111,
    rating: 5.0,
    image: "https://customer-assets.emergentagent.com/job_8c1ccbd6-9b69-4f77-851f-db987073ebdb/artifacts/cf2j0myj_image.webp"
  },
  {
    id: 8,
    title: "كورس المعرفة الفائقة",
    price: 999,
    rating: 5.0,
    image: "https://customer-assets.emergentagent.com/job_8c1ccbd6-9b69-4f77-851f-db987073ebdb/artifacts/cf2j0myj_image.webp"
  }
];

export const dubbedCourses = [
  {
    id: 1,
    title: "Spiritual Lecture (English Dubbed)",
    language: "English",
    duration: "12 hours",
    description: "Experience profound spiritual teachings translated for a global English-speaking audience.",
    image: "https://customer-assets.emergentagent.com/job_2c4680bd-c347-4d6a-a0a4-870ac2e747e5/artifacts/01y7i3tl_1.jpeg"
  },
  {
    id: 2,
    title: "Conferencia Espiritual (Doblado al Español)",
    language: "Español",
    duration: "10 hours",
    description: "Enseñanzas espirituales profundas dobladas al español para la comunidad hispanohablante.",
    image: "https://customer-assets.emergentagent.com/job_2c4680bd-c347-4d6a-a0a4-870ac2e747e5/artifacts/seliwhym_2.jpeg"
  },
  {
    id: 3,
    title: "Deutsche Synchronisation (German Dubbed)",
    language: "Deutsch",
    duration: "11 hours",
    description: "Spirituelle Vorträge in 4K Qualität mit deutscher Synchronisation für tiefgreifendes Lernen.",
    image: "https://customer-assets.emergentagent.com/job_2c4680bd-c347-4d6a-a0a4-870ac2e747e5/artifacts/f3c38uxt_3.jpeg"
  },
  {
    id: 4,
    title: "中文配音 (Chinese Dubbed)",
    language: "中文",
    duration: "11 hours",
    description: "心灵讲座中文配音版，带您探索内心的平静与智慧。",
    image: "https://customer-assets.emergentagent.com/job_2c4680bd-c347-4d6a-a0a4-870ac2e747e5/artifacts/2mbw1xom_4.jpeg"
  }
];

export const charities = [
  {
    id: 1,
    title: "Messengers of Love",
    arabicTitle: "مجموعة رسل المحبة",
    description: "Spreading love and peace everywhere through acts of kindness and helping the needy without discrimination."
  },
  {
    id: 2,
    title: "Fostering Human Values",
    arabicTitle: "مجموعة تنشيط القيم الإنسانية",
    description: "Promoting moral and human values in society to build a conscious and responsible generation."
  },
  {
    id: 3,
    title: "One World One Family",
    arabicTitle: "مجموعة عالم واحد وعائلة واحدة",
    description: "Uniting hearts and building bridges of connection between different cultures and peoples."
  },
  {
    id: 4,
    title: "Medical Service Camps",
    arabicTitle: "المعسكرات الطبية الخدمية",
    description: "Providing healthcare to the needy and offering free treatment and medicine in remote areas."
  }
];

export const teachings = [
  {
    id: 1,
    title: "Ancient Wisdom",
    description: "Drawing from centuries of spiritual knowledge"
  },
  {
    id: 2,
    title: "Compassionate Living",
    description: "Practicing kindness in every action"
  },
  {
    id: 3,
    title: "Mindful Presence",
    description: "Living fully in the present moment"
  },
  {
    id: 4,
    title: "Holistic Healing",
    description: "Addressing body, mind, and spirit"
  }
];

export const missionVision = [
  {
    id: 1,
    title: "Our Purpose",
    description: "To guide seekers towards spiritual truth"
  },
  {
    id: 2,
    title: "Global Reach",
    description: "Connecting hearts across borders"
  },
  {
    id: 3,
    title: "Community",
    description: "Building a supportive spiritual family"
  },
  {
    id: 4,
    title: "Transformation",
    description: "Facilitating deep personal change"
  }
];

export const socialLinks = [
  { name: "Facebook", url: "#" },
  { name: "YouTube", url: "#" },
  { name: "X (Twitter)", url: "#" },
  { name: "Instagram", url: "#" },
  { name: "WhatsApp", url: "#" },
  { name: "Gmail", url: "#" }
];

export const languages = [
  { code: "en", name: "English", label: "ENGLISH" },
  { code: "ar", name: "العربية", label: "ARABIC" },
  { code: "ru", name: "Русский", label: "RUSSIAN" },
  { code: "hi", name: "हिन्दी", label: "HINDI" },
  { code: "fr", name: "Français", label: "FRENCH" },
  { code: "zh", name: "中文", label: "CHINESE" },
  { code: "ta", name: "தமிழ்", label: "TAMIL" },
  { code: "it", name: "Italiano", label: "ITALIAN" },
  { code: "es", name: "Español", label: "SPANISH" }
];

export const donationAmounts = [5, 10, 25, 50, 100];
